import {
  applyDynamicVariableSyntaxLiquid,
  SchemaType,
} from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { parseAndTransformSmsText } from "@redotech/redo-model/sms-text-parser";
import * as styles from "./sms-content-parser.module.css";

export function sanitizeSmsContent(
  content: string,
  autoShortenLinks: boolean,
  linkPreviewUrl: string,
  schemaType: SchemaType | null,
) {
  let keyCounter = 0;
  const getUniqueKey = (prefix: string) => `${prefix}-${keyCounter++}`;

  const segments = parseAndTransformSmsText<React.ReactNode>(content, {
    onText: (text) => <span key={getUniqueKey("text")}>{text}</span>,
    onLink: (url) => (
      <span className={styles.underlinedLink} key={getUniqueKey("link")}>
        {autoShortenLinks ? linkPreviewUrl : url}
      </span>
    ),
    onDiscount: () => (
      <span key={getUniqueKey("discount")}>%discount-code%</span>
    ),
    onDiscountLink: () => (
      <span
        className={styles.underlinedLink}
        key={getUniqueKey("discountLink")}
      >
        {linkPreviewUrl}
      </span>
    ),
    onVariable: (variable, defaultValue) => (
      <span key={getUniqueKey("variable")}>
        {applyDynamicVariableSyntaxLiquid({
          key: variable,
          default: defaultValue,
          isHtml: false,
          schemaType,
        })}
      </span>
    ),
    onNewline: () => <br key={getUniqueKey("newline")} />,
  });

  return <>{segments}</>;
}
